const Builder = require('../BuilderBase');

module.exports = class DefaultToPreviousSelection extends Builder {
    constructor(properties) {
        super('transform_DefaultToPreviousSelection', '', properties);
    }
};
